import { render, staticRenderFns } from "./AgentSwitchAccount.vue?vue&type=template&id=06ebecb2"
import script from "./AgentSwitchAccount.vue?vue&type=script&lang=js"
export * from "./AgentSwitchAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports